// Page: enrolled-accounts  (dashboard listing of a returning user's enrolled deals)
//
// Ported from the inline <script> in
//   Enrollment_modules/dashboard/enrolled-accounts.module/module.html (lines 48–1875).
//
// MECHANICAL / FAITHFUL PORT — runtime behaviour is preserved. Deliberate changes,
// same family as the pilots (see docs/handoff/global-js-deep-refactor-notes.md):
//   1. This module's OWN elements (`.enrolledAccounts-btn a`,
//      `.enrolledAccounts-list .listContent`, `.enrolledAccounts-listSection`) are
//      scoped to `root`. Everything else stays document-scoped exactly as before:
//      the loader overlays (#MEZloaderOverlay / #multienterZipLoader — siblings of
//      root, not children), page-wide `button`/`a` queries, `body`, the referral
//      input `#gsicode`, the cross-module popups (`.lfcsiya-main.findSolarPopup`,
//      `.accountDetailsView-*`) and `#Page_0_Project_Found_widget #addressAppend`
//      (none of which live inside this module).
//   2. `_hcms/api/*` fetches are ROOT-RELATIVE via core/api `apiUrl`, and the
//      same-origin enrollment step redirects (https://enrollment.nautilussolar.com/…)
//      are now relative paths ("/my-info?mltenlmt", "/my-usage", …).
//   3. HubDB reads go through core/hubdb `hubdbRowsUrl` (table id + portal from
//      window.__ENV__) instead of inline literals.
//   4. localStorage goes through core/storage rawGet/rawSet/rawRemove (the many
//      loosely-named keys here aren't all in the typed StorageKey union yet).
//   5. STRICT-MODE fix: `logcheckConsentConfigurationVariation` assigned a bare
//      `rows = …` with no `var` in that function (an implicit global in the old
//      sloppy-mode inline script). It now has a local `let rows: any;` so strict
//      ESM doesn't throw ReferenceError.
//
// KNOWN LATENT BUGS preserved verbatim (NOT fixed — out of scope; see final report):
//   - `fillLocalStorage` recurses via `checkUtilityIdInFarmTable(U_Id)`, a name
//     that is never defined in this module (only exists in entry-form). Kept as a
//     `(globalThis as any)` reference so it still fails the same way at runtime
//     (the failing pagination branch only fires at exactly `limit` rows and is
//     swallowed by the surrounding fetch `.catch`).
//   - `verifyUtilityButton` handler uses `if (sbs = 'Yes')` — an assignment, not a
//     comparison (always truthy). Preserved as-is.
//
// Dynamic ES5 patterns (vars reassigned across types, HubDB/deal row shapes) are
// typed `any` and `var` declarations are kept to keep the port mechanical.
// External globals (first_visited_url, dealOwner) are declared in global.d.ts.

import { apiUrl } from "../../core/api"
import { hubdbRowsUrl } from "../../core/hubdb"
import * as storage from "../../core/storage"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/account/enrolled-accounts.ts","init",[root,_config],["root","_config"]);
  var responseFromAPI: any = ""

  /* loader function */
  function enterZipOpenLoader() {
__ea_trace("modules/account/enrolled-accounts.ts","enterZipOpenLoader",[],[]);
    var loader = document.getElementById("multienterZipLoader") as HTMLElement
    var body = document.querySelector("body")
    void body
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    ;(document.getElementById("MEZloaderOverlay") as HTMLElement).style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as any).disabled = true
    })
  }
  function enterZipcloseLoader() {
__ea_trace("modules/account/enrolled-accounts.ts","enterZipcloseLoader",[],[]);
    var loader = document.getElementById("multienterZipLoader") as HTMLElement
    var body = document.querySelector("body")
    void body
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    ;(document.getElementById("MEZloaderOverlay") as HTMLElement).style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as any).disabled = false
    })
  }
  /* loader function */
  enterZipOpenLoader()

  ;(root.querySelector(".enrolledAccounts-btn a") as HTMLAnchorElement).onclick = (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
    event.preventDefault() // Prevent the default redirection
    showPopup() // Show the popup
  }
  function showPopup() {
__ea_trace("modules/account/enrolled-accounts.ts","showPopup",[],[]);
    ;(document.querySelector(".lfcsiya-main.findSolarPopup") as HTMLElement).style.display = "block"
  }
  function showDetailsViewPopup() {
__ea_trace("modules/account/enrolled-accounts.ts","showDetailsViewPopup",[],[]);
    ;(document.querySelector(".accountDetailsView-main") as HTMLElement).style.display = "block"
  }

  var _utilityIdSession: any
  var _LmiAvailability: any
  var _LmiCensusAvailability: any
  var DisplayLmiElementList: any[] = []
  var requireLmiElementList: any[] = []
  var DisplayUsageElementList: any[] = []
  var requireUsageElementList: any[] = []
  var DisplayConsentElementList: any[] = []
  var requireConsentElementList: any[] = []
  var consetPaymentReq: any
  var sampleSessiontype: any
  var sampleOriginType: any
  var errorCount = 0
  void errorCount
  void DisplayLmiElementList
  void requireLmiElementList
  var log_Utname: any
  var globalDealId: any
  var log_utilityID: any
  async function getUtilityNameFromDeal(dealId: any) {
__ea_trace("modules/account/enrolled-accounts.ts","getUtilityNameFromDeal",[dealId],["dealId"]);
    globalDealId = dealId
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      const dataa = await response.json()
      if (dataa.message === "No User Found") {
      } else if (dataa.message === "User Found") {
        log_Utname = dataa.userValue.properties.utility_name
        var log_utilityIDn = dataa.userValue.properties.utility_id
        log_utilityID = dataa.userValue.properties.utility_id
        var log_zipCoden = dataa.userValue.properties.postal_code
        var log_repid = dataa.userValue.properties.attribution_rep
        var log_attcode = dataa.userValue.properties.attribution_code
        var log_refUrl = dataa.userValue.properties.referral_url
        var l_dealId = dataa.userValue.id
        var street_address_1 = dataa.userValue.properties.street_address
        var street_address_2 = dataa.userValue.properties.street_address_2
        var service_city = dataa.userValue.properties.city
        var service_state_abbreviation = dataa.userValue.properties.service_state_abbreviation
        var county = dataa.userValue.properties.county
        var Service_postal_code = dataa.userValue.properties.postal_code
        void Service_postal_code
        if (log_utilityIDn != null) {
          storage.rawSet("utility_id", log_utilityIDn)
        }
        if (log_zipCoden != null) {
          storage.rawSet("zip_code", log_zipCoden)
        }
        if (log_Utname != null) {
          storage.rawSet("utility_Name", log_Utname)
        }
        storage.rawSet("county", county)
        storage.rawSet(
          "Address",
          street_address_1 + ", " + street_address_2 + ", " + service_city + ", " + service_state_abbreviation,
        )
        if (log_attcode != null) {
          if (log_attcode.trim() !== "") {
            if (log_attcode !== "null") {
              storage.rawSet("repid", log_repid)
              storage.rawSet("attcode", log_attcode)
              storage.rawSet("referralUrl", log_refUrl)

              const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
                attribution_code: log_attcode,
                default_broker_contact: 1,
              })
              fetch(hubDBEndpoint, {
                method: "GET",
              })
                .then((response) => response.json())
                .then((data) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[data],["data"]);
                  const rows = data.objects
                  if (rows.length >= 1) {
                    for (var i = 0; i < rows.length; i++) {
                      const element = rows[i]
                      if (element.values["5"].includes(log_repid) && element.values["5"].includes(log_attcode)) {
                        var brokerRepPhoneNo = element.values["6"]
                        var brokerRepEmail = element.values["7"]
                        var brokerRepTitle = element.values["9"]
                        var brokerRepName = element.values["4"]
                        var brokerCompany = element.values["2"]
                        if (element.values["8"] !== undefined) {
                          var brokerRepImage = element.values["8"].url
                          storage.rawSet("brokerRepImage", brokerRepImage)
                        }
                        if (element.values["13"] !== undefined) {
                          var brokerMeetingUrl = element.values["13"].url
                          storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                        }
                        storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                        storage.rawSet("brokerRepEmail", brokerRepEmail)
                        storage.rawSet("brokerRepTitle", brokerRepTitle)
                        if (brokerRepName !== undefined) {
                          storage.rawSet("brokerRepName", brokerRepName)
                        }
                        storage.rawSet("brokerCompany", brokerCompany)
                        storage.rawSet("sidebarBrokerDisplay", "Yes")
                        break
                      } else {
                        if (i === rows.length - 1) {
                          // Code to execute on the last iteration
                          for (var k = 0; k < rows.length; k++) {
                            const elementt = rows[k]
                            if (elementt.values["5"].includes(log_attcode)) {
                              if (elementt.values["12"] === 1) {
                                var brokerRepPhoneNo2 = elementt.values["6"]
                                var brokerRepEmail2 = elementt.values["7"]
                                var brokerRepTitle2 = elementt.values["9"]
                                var brokerRepName2 = elementt.values["4"]
                                var brokerCompany2 = elementt.values["2"]
                                if (elementt.values["8"] !== undefined) {
                                  var brokerRepImage2 = elementt.values["8"].url
                                  storage.rawSet("brokerRepImage", brokerRepImage2)
                                }
                                if (elementt.values["13"] !== undefined) {
                                  var brokerMeetingUrl2 = elementt.values["13"].url
                                  storage.rawSet("brokerMeetingUrl", brokerMeetingUrl2)
                                }
                                storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo2)
                                storage.rawSet("brokerRepEmail", brokerRepEmail2)
                                storage.rawSet("brokerRepTitle", brokerRepTitle2)
                                if (brokerRepName2 !== undefined) {
                                  storage.rawSet("brokerRepName", brokerRepName2)
                                }
                                storage.rawSet("brokerCompany", brokerCompany2)
                                storage.rawSet("sidebarBrokerDisplay", "Yes")
                                break
                              } else {
                                if (k === rows.length - 1) {
                                  storage.rawRemove("attcode")
                                  storage.rawRemove("repid")
                                  storage.rawSet("sidebarBrokerDisplay", "No")
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  } else {
                    storage.rawRemove("attcode")
                    storage.rawRemove("repid")
                    storage.rawSet("sidebarBrokerDisplay", "No")
                  }
                })
            }
          }
        }
        storage.rawSet("dealId", l_dealId)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function CheckIfUserExist(
    dealId: any,
    redirectUrl: any,
    particularSectionName: any,
    particularSectionValue: any,
  ) {
__ea_trace("modules/account/enrolled-accounts.ts","CheckIfUserExist",[dealId,redirectUrl,particularSectionName,particularSectionValue],["dealId","redirectUrl","particularSectionName","particularSectionValue"]);
    var email = storage.rawGet("logEmail") as string
    email = email.toLowerCase()
    storage.rawSet("dealId", email)
    var catchdata: any = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "No User Found") {
        enterZipcloseLoader()
        //                 document.querySelector('#page_0_returning_user_widget #userNotExist').innerHTML = 'User does not exist';
      } else if (dataa.message === "User Found") {
        await getUtilityNameFromDeal(dealId)
        var log_referral_url = dataa.userValue.properties.referral_url
        void log_referral_url
        var log_attribution_code = dataa.userValue.properties.attribution_code
        var recordId = dataa.userValue.properties.hs_object_id
        var firstName = dataa.userValue.properties.firstname
        var lastName = dataa.userValue.properties.lastname
        var onboardToken = dataa.userValue.properties.bayou_onboarding_token
        var home_phone = dataa.userValue.properties.phone
        var cell_phone = dataa.userValue.properties.mobilephone
        var dateOfBirth = dataa.userValue.properties.date_of_birth
        var bayouContactId = dataa.userValue.properties.bayou_contact_id
        var is_enrolled_for_bayou = dataa.userValue.properties.is_enrolled_for_bayou
        storage.rawSet("RecordId", recordId)
        storage.rawSet("LoggedName", `${firstName} ${lastName}`)
        storage.rawSet("FirstName", firstName)
        storage.rawSet("LastName", lastName)
        storage.rawSet("CompanyName", `${firstName}&${lastName}`)
        storage.rawSet("DateOfBirth", dateOfBirth)
        storage.rawSet("onboarding_token", onboardToken)
        storage.rawSet("bayou_contact_id", bayouContactId)
        storage.rawSet("BayouContactId", bayouContactId)
        storage.rawSet("CellPhone", cell_phone)
        storage.rawSet("HomePhone", home_phone)
        if (is_enrolled_for_bayou === "yes") {
          storage.rawSet("is_enrolled_for_bayou", "yes")
        }
        if (log_attribution_code != null && log_attribution_code !== "") {
          sampleOriginType = "Invite"
          sampleSessiontype = "Consumer Completing"
        } else {
          sampleOriginType = "Direct"
          sampleSessiontype = "Consumer Only"
        }
        await fillLocalStorage(log_utilityID)
        await SaveSessionDetailsOnLocalStorage(log_utilityID)

        await addDataToContactRecord(email, particularSectionValue)
        if (storage.rawGet("userEmail") !== email) {
          if (storage.rawGet("skipUsage") !== null) {
            storage.rawRemove("skipUsage")
          }
        }
        storage.rawSet("userEmail", email.toLowerCase())
        await addUserAgentData(redirectUrl, particularSectionName, particularSectionValue)
        var l_contactId = dataa.userValue.id
        storage.rawSet("contactId", l_contactId)
      }
    } catch (error) {
      enterZipcloseLoader()
      console.error("Error:", error)
    }
  }

  var limitt = 1000
  var offsett = 0
  var allFarmRowss: any[] = []
  async function fillLocalStorage(U_Id: any) {
__ea_trace("modules/account/enrolled-accounts.ts","fillLocalStorage",[U_Id],["U_Id"]);
    //Live farm table id 15223639

    const hubDBEndpoint = hubdbRowsUrl("utilityFarm", {
      limit: limitt,
      offset: offsett,
    })
    fetch(hubDBEndpoint, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[data],["data"]);
        const matchingRowss = data.objects.filter((row: any) => row.values[10] === U_Id)
        const rowss = data.objects
        allFarmRowss = allFarmRowss.concat(matchingRowss)
        if (rowss.length === limitt) {
          // There might be more rows, fetch the next page
          offsett += limitt
          // NOTE: `checkUtilityIdInFarmTable` is not defined in this module (only in
          // entry-form). Preserved verbatim as a latent bug — see file header.
          return (globalThis as any).checkUtilityIdInFarmTable(U_Id)
        }
        const priorityArray: any[] = []
        for (var i = 0; i <= allFarmRowss.length; i++) {
          const currentobj = allFarmRowss[i]
          const FarmStateAbbreviation = currentobj.values[5]
          const FarmZip = currentobj.values[6]
          const FarmName = currentobj.values[7]
          const FarmID = currentobj.values[1]
          const priority = currentobj.values[12]
          const FarmDisplayName = currentobj.values[2]
          const FarmStreetAddress1 = currentobj.values[3]
          const FarmStreetAddress2 = currentobj.values[13]
          const FarmCity = currentobj.values[4]
          const FarmEmail = currentobj.values[28]
          const FarmPhoneNumber = currentobj.values[23]
          const FarmProjectDescription = currentobj.values[22]
          const FarmLlc = currentobj.values[21]
          const FarmLMIDiscount = currentobj.values[19]
          const FarmOpenDiscount = currentobj.values[20]
          const FarmCounty = currentobj.values[35]
          const myObject = {
            FarmZip: FarmZip,
            FarmName: FarmName,
            FarmID: FarmID,
            priority: priority,
            FarmDisplayName: FarmDisplayName,
            FarmStreetAddress1: FarmStreetAddress1,
            FarmStreetAddress2: FarmStreetAddress2,
            FarmCity: FarmCity,
            FarmEmail: FarmEmail,
            FarmStateAbbreviation: FarmStateAbbreviation,
            FarmPhoneNumber: FarmPhoneNumber,
            FarmProjectDescription: FarmProjectDescription,
            FarmLlc: FarmLlc,
            FarmLMIDiscount: FarmLMIDiscount,
            FarmOpenDiscount: FarmOpenDiscount,
            FarmCounty: FarmCounty,
          }
          if (currentobj.values[9] === 1) {
            priorityArray.push(myObject)
          }
          if (i === allFarmRowss.length - 1) {
            // Now correspondingObject contains the object with the lowest priority
            const minPriorityObject = priorityArray.reduce(
              (min, obj) => (obj.priority < min.priority ? obj : min),
              priorityArray[0],
            )
            var addressAppend = document.querySelector("#Page_0_Project_Found_widget #addressAppend") as HTMLElement
            addressAppend.textContent =
              minPriorityObject.FarmStreetAddress1 +
              ", " +
              minPriorityObject.FarmCity +
              ", " +
              minPriorityObject.FarmStateAbbreviation
            storage.rawSet("FarmStreetAddress1", minPriorityObject.FarmStreetAddress1)
            storage.rawSet("FarmStreetAddress2", minPriorityObject.FarmStreetAddress2)
            storage.rawSet("FarmCity", minPriorityObject.FarmCity)
            storage.rawSet("FarmStateAbbreviation", minPriorityObject.FarmStateAbbreviation)
            storage.rawSet("FarmName", minPriorityObject.FarmName)
            storage.rawSet("FarmID", minPriorityObject.FarmID)
            storage.rawSet("FarmPhoneNumber", minPriorityObject.FarmPhoneNumber)
            storage.rawSet("FarmEmail", minPriorityObject.FarmEmail)
            storage.rawSet("FarmProjectDescription", minPriorityObject.FarmProjectDescription)
            storage.rawSet("FarmLlc", minPriorityObject.FarmLlc)
            storage.rawSet("FarmDisplayName", minPriorityObject.FarmDisplayName)
            storage.rawSet("FarmLMIDiscount", minPriorityObject.FarmLMIDiscount)
            storage.rawSet("FarmOpenDiscount", minPriorityObject.FarmOpenDiscount)
            storage.rawSet("FarmCounty", minPriorityObject.FarmCounty)
          }
        }
      })
      .catch((error) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[error],["error"]);
        console.error("Error fetching data from HubDB:", error)
      })
  }
  async function SaveSessionDetailsOnLocalStorage(exampleUtilityId: any) {
__ea_trace("modules/account/enrolled-accounts.ts","SaveSessionDetailsOnLocalStorage",[exampleUtilityId],["exampleUtilityId"]);
    const hubDBEndpoint = hubdbRowsUrl("utilityAvailability", {
      utility_id__eq: exampleUtilityId,
    })
    const response = await fetch(hubDBEndpoint, { method: "GET" })
    const data = await response.json()
    const rows = data.objects
    if (rows.length >= 1) {
      storage.rawSet("Config ID", rows[0].id)
      rows.forEach((element: any) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          storage.rawSet("SessionDetails", JSON.stringify(element.values))
          storage.rawSet("stateForLMIConfig", element.values["13"].name)
          storage.rawSet("UtilitySessionDetails", JSON.stringify(element.values))
          storage.rawSet("UtilityRate", element.values["78"])
          storage.rawSet("SubSizingFactor", element.values["79"])
          storage.rawSet("standardRate", element.values["80"])
          storage.rawSet("lmiNseRate", element.values["81"])
          storage.rawSet("standardRate", element.values["80"])
          storage.rawSet("lmiNseRate", element.values["81"])
          storage.rawSet("acSystemSize", element.values["82"])
          storage.rawSet("acKwh", element.values["84"])
        } else {
        }
      })
    }
  }
  async function addDataToContactRecord(email: any, particularSectionValue: any) {
__ea_trace("modules/account/enrolled-accounts.ts","addDataToContactRecord",[email,particularSectionValue],["email","particularSectionValue"]);
    var checkUID1 = storage.rawGet("utility_id")
    var UserDevice_1 = storage.rawGet("User Device")
    var BrowserName_1 = storage.rawGet("Browser Name")
    var opratingSystem_1 = storage.rawGet("Operating System")
    var catchdata: any = ""
    try {
      const data = {
        properties: {
          email: email,
          internal_contact_source: "enrollment website",
          enrollment_utility_id: checkUID1,
          user_agent: BrowserName_1,
          user_device: UserDevice_1,
          user_agent___operating_system: opratingSystem_1,
          first_visited_url: first_visited_url,
        },
      }
      const response = await fetch(apiUrl("UpdateContactRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        loggetAvalability(particularSectionValue)
      }
      responseFromAPI = await response.json()
      responseFromAPI = JSON.stringify(responseFromAPI)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  /*** --------------------------- variations my info code ---------------------------------- ****/
  async function loggetAvalability(particularSectionValue: any) {
__ea_trace("modules/account/enrolled-accounts.ts","loggetAvalability",[particularSectionValue],["particularSectionValue"]);
    var exampleUtilityId = storage.rawGet("utility_id")
    // live session config id 15223637
    const hubDBEndpoint = hubdbRowsUrl("utilityAvailability", {
      utility_id__eq: exampleUtilityId as string,
    })
    const response = await fetch(hubDBEndpoint, { method: "GET" })
    const data = await response.json()
    const rows = data.objects
    var IsUtilityIdMatched = false
    void IsUtilityIdMatched
    if (rows.length >= 1) {
      storage.rawSet("Session Config ID", rows[0].id)
      rows.forEach((element: any) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          storage.rawSet("stateForLMIConfig", element.values["13"].name)
          storage.rawSet("UtilitySessionDetails", JSON.stringify(element.values))
          IsUtilityIdMatched = true
          _utilityIdSession = element.values["1"]

          if (element.values["30"] === "1") {
            _LmiAvailability = "Yes"
          } else if (element.values["30"] === "0") {
            _LmiAvailability = "No"
          } else {
            _LmiAvailability = ""
          }
          if (element.values["31"] === "1") {
            _LmiCensusAvailability = "Yes"
          } else if (element.values["31"] === "0") {
            _LmiCensusAvailability = "No"
          } else {
            _LmiCensusAvailability = ""
          }
          logcheckLMIConfigurationVariation(particularSectionValue)
        } else {
        }
      })
    }
  }
  // check variation for the LMI page ----------------------------------------------------------------------------------------------
  async function logcheckLMIConfigurationVariation(particularSectionValue: any) {
__ea_trace("modules/account/enrolled-accounts.ts","logcheckLMIConfigurationVariation",[particularSectionValue],["particularSectionValue"]);
    void particularSectionValue
    // live site lmi configuration table id 15221612
    await logcheckUsageConfigurationVariation()
    await logcheckConsentConfigurationVariation()
  }
  // check variation for the LMI page ----------------------------------------------------------------------------------------------
  async function logcheckUsageConfigurationVariation() {
__ea_trace("modules/account/enrolled-accounts.ts","logcheckUsageConfigurationVariation",[],[]);
    var usageAvaiablity
    var rows
    var SessionLocalStorage = await JSON.parse(storage.rawGet("UtilitySessionDetails") as string)
    if (SessionLocalStorage["32"] === 0) {
      usageAvaiablity = "No"
    } else if (SessionLocalStorage["32"] === 1) {
      usageAvaiablity = "Yes"
    } else {
      usageAvaiablity = ""
    }
    void usageAvaiablity
    //usage config old id 7594021
    // live 15224913
    try {
      const hubDBEndpoint = hubdbRowsUrl("usageConfig", {
        usage_required_for_contract__eq: "Yes",
        origin_type__eq: sampleOriginType,
        session_type__eq: sampleSessiontype,
      })

      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      rows = data.objects

      if (rows.length >= 1) {
        if (rows[0].values["5"].name === "Yes") {
          DisplayUsageElementList.push("UTILITY CREDENTIALS DISPLAY")
        }
        if (rows[0].values["7"].name === "Yes") {
          DisplayUsageElementList.push("CREATE UTILITY ACCOUNT DISPLAY")
        }
        if (rows[0].values["9"].name === "Yes") {
          DisplayUsageElementList.push("SKIP FOR NOW DISPLAY")
        }
        if (rows[0].values["11"].name === "Yes") {
          DisplayUsageElementList.push("UTILITY ACCOUNT NUMBER DISPLAY")
        }
        if (rows[0].values["13"].name === "Yes") {
          DisplayUsageElementList.push("BILL UPLOAD DISPLAY")
        }

        if (rows[0].values["6"].name === "Yes") {
          requireUsageElementList.push("UTILITY CREDENTIALS REQUIRED")
        }
        if (rows[0].values["8"].name === "Yes") {
          requireUsageElementList.push("CREATE UTILITY ACCOUNT REQUIRED")
        }
        if (rows[0].values["10"].name === "Yes") {
          requireUsageElementList.push("SKIP FOR NOW REQUIRED")
        }
        if (rows[0].values["12"].name === "Yes") {
          requireUsageElementList.push("UTILITY ACCOUNT NUMBER REQUIRED")
        }
        if (rows[0].values["14"].name === "Yes") {
          requireUsageElementList.push("BILL UPLOAD REQUIRED")
        }

        storage.rawSet("usageDisplayelementList", JSON.stringify(DisplayUsageElementList))
        storage.rawSet("usagerequireElementList", JSON.stringify(requireUsageElementList))
        if (DisplayUsageElementList.length > 1) {
          // window.location.href = "https://enrollment.nautilussolar.com/page_2_my_usage";
        } else {
          // window.location.href = "https://enrollment.nautilussolar.com/page_2_my_usage";
        }
      } else {
        storage.rawSet("usageDisplayelementList", JSON.stringify(DisplayUsageElementList))
        storage.rawSet("usagerequireElementList", JSON.stringify(requireUsageElementList))
      }
    } catch (error) {
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  async function logcheckConsentConfigurationVariation() {
__ea_trace("modules/account/enrolled-accounts.ts","logcheckConsentConfigurationVariation",[],[]);
    // STRICT-MODE fix: `rows` was an implicit global in the sloppy-mode inline
    // script (no `var` in this function). Declared locally here.
    let rows: any
    var SessionLocalStorage = JSON.parse(storage.rawGet("UtilitySessionDetails") as string)
    if (SessionLocalStorage["33"] === 0) {
      consetPaymentReq = "No"
    } else if (SessionLocalStorage["33"] === 1) {
      consetPaymentReq = "Yes"
    } else {
      consetPaymentReq = "No"
    }
    //old consent id 7588247
    // live 15223652
    const hubDBEndpoint = hubdbRowsUrl("paymentConfig", {
      payment_required_for_billing__eq: consetPaymentReq,
      origin_type__eq: sampleOriginType,
      session_type__eq: sampleSessiontype,
    })
    try {
      const response = await fetch(hubDBEndpoint, { method: "GET" })
      const data = await response.json()
      rows = data.objects

      if (rows.length >= 1) {
        if (rows[0].values["5"].name === "Yes") {
          DisplayConsentElementList.push("PAYMENT OPTIONS DISPLAY")
        }
        if (rows[0].values["7"].name === "Yes") {
          DisplayConsentElementList.push("AUTHORIZATION CONSENT DISPLAY")
        }
        if (rows[0].values["9"].name === "Yes") {
          DisplayConsentElementList.push("CREDIT CHECK CONSENT DISPLAY")
        }
        if (rows[0].values["11"].name === "Yes") {
          DisplayConsentElementList.push("SUBSCRIPTION SIGNATURE DISPLAY")
        }
        if (rows[0].values["13"].name === "Yes") {
          DisplayConsentElementList.push("SUB ACKNOWLEDGMENT DISPLAY")
        }
        if (rows[0].values["15"].name === "Yes") {
          DisplayConsentElementList.push("DISCLOSURE SIGNATURE DISPLAY")
        }
        if (rows[0].values["17"].name === "Yes") {
          DisplayConsentElementList.push("DISC ACKNOWLEDGMENT DISPLAY")
        }
        if (rows[0].values["19"].name === "Yes") {
          DisplayConsentElementList.push("SUBSCRIPTION SIGNATURE SIGN DISPLAY")
        }
        if (rows[0].values["21"].name === "Yes") {
          DisplayConsentElementList.push("DISCLOSURE SIGNATURE SIGNED DISPLAY")
        }

        if (rows[0].values["6"].name === "Yes") {
          requireConsentElementList.push("PAYMENT OPTIONS REQUIRED")
        }
        if (rows[0].values["8"].name === "Yes") {
          requireConsentElementList.push("AUTHORIZATION CONSENT REQUIRED")
        }
        if (rows[0].values["10"].name === "Yes") {
          requireConsentElementList.push("CREDIT CHECK CONSENT REQUIRED")
        }
        if (rows[0].values["12"].name === "Yes") {
          requireConsentElementList.push("SUBSCRIPTION SIGNATURE REQUIRED")
        }
        if (rows[0].values["14"].name === "Yes") {
          requireConsentElementList.push("SUB ACKNOWLEDGMENT REQUIRED")
        }
        if (rows[0].values["16"].name === "Yes") {
          requireConsentElementList.push("DISCLOSURE SIGNATURE REQUIRED")
        }
        if (rows[0].values["18"].name === "Yes") {
          requireConsentElementList.push("DISC ACKNOWLEDGMENT REQUIRED")
        }
        if (rows[0].values["20"].name === "Yes") {
          requireConsentElementList.push("SUBSCRIPTION SIGNATURE SIGN REQUIRED")
        }
        if (rows[0].values["22"].name === "Yes") {
          requireConsentElementList.push("DISCLOSURE SIGNATURE SIGNED REQUIRED")
        }
        storage.rawSet("consentDisplayelementList", JSON.stringify(DisplayConsentElementList))
        storage.rawSet("consentrequireElementList", JSON.stringify(requireConsentElementList))
        if (DisplayConsentElementList.length > 1) {
          // window.location.href = "https://enrollment.nautilussolar.com/page_1_lmi";
        } else {
          // window.location.href = "https://enrollment.nautilussolar.com/page_2_my_usage"; // redirect to login page
        }
      } else {
        storage.rawSet("consentDisplayelementList", JSON.stringify(DisplayConsentElementList))
        storage.rawSet("consentrequireElementList", JSON.stringify(requireConsentElementList))
      }
    } catch (error) {
      console.error("Error in Usage hubdb fetch block:", error)
    }
  }
  /*** ----------------------------------------- variations my info code ----------------------------------------- ****/
  async function addUserAgentData(redirectUrl: any, particularSectionName: any, particularSectionValue: any) {
__ea_trace("modules/account/enrolled-accounts.ts","addUserAgentData",[redirectUrl,particularSectionName,particularSectionValue],["redirectUrl","particularSectionName","particularSectionValue"]);
    var UserDevice_1 = storage.rawGet("User Device")
    var BrowserName_1 = storage.rawGet("Browser Name")
    var opratingSystem_1 = storage.rawGet("Operating System")
    var catchdata: any = ""
    try {
      const data = {
        properties: {
          deal_id: globalDealId,
          user_agent: BrowserName_1,
          user_device: UserDevice_1,
          user_agent___operating_system: opratingSystem_1,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
        await CheckDealStageAndRedirectAccordingly(redirectUrl, particularSectionName, particularSectionValue)
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  // ------------- get Deal stage and redirect the page accordingly -------------------------------

  async function CheckDealStageAndRedirectAccordingly(
    redirectUrl: any,
    particularSectionName: any,
    particularSectionValue: any,
  ) {
__ea_trace("modules/account/enrolled-accounts.ts","CheckDealStageAndRedirectAccordingly",[redirectUrl,particularSectionName,particularSectionValue],["redirectUrl","particularSectionName","particularSectionValue"]);
    enterZipcloseLoader()
    storage.rawSet(particularSectionName, particularSectionValue)
    window.location.href = redirectUrl
  }
  // ------------- get Deal stage and redirect the page accordingly -------------------------------

  async function viewDealItems(dealId: any, _stateAB?: any) {
__ea_trace("modules/account/enrolled-accounts.ts","viewDealItems",[dealId,_stateAB],["dealId","_stateAB"]);
    var catchdata: any = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      var l_dealStage = dataa.userValue.properties.dealstage
      var completionDate: any = dataa.userValue.properties.hs_v2_date_entered_127892575
      var completionDateIl = dataa.userValue.properties.hs_v2_date_entered_984219225
      var log_email = dataa.userValue.properties.deal_email_test
      void log_email
      var l_dealId = dataa.userValue.id
      void l_dealId

      var street_address_1 = dataa.userValue.properties.street_address
      var street_address_2 = dataa.userValue.properties.street_address_2
      if (street_address_2 == null) {
        street_address_2 = ""
      }
      var service_city = dataa.userValue.properties.city
      var service_state_abbreviation = dataa.userValue.properties.service_state_abbreviation
      var county = dataa.userValue.properties.county
      void county
      var Service_postal_code = dataa.userValue.properties.postal_code
      var enrollment_number = dataa.userValue.properties.enrollment_number
      var utility_account_number = dataa.userValue.properties.uan_1_value
      void utility_account_number
      var comb_utility_account_number = dataa.userValue.properties.combined_utility_account_number
      if (comb_utility_account_number == null || comb_utility_account_number === "") {
        comb_utility_account_number = "Not Yet Provided"
      }
      var payment_method = dataa.userValue.properties.payment_method
      if (payment_method === "Credit Card") {
        payment_method = "CC"
      }
      var lmi_optionn = dataa.userValue.properties.lmi_option
      var lmi_option = "Yes"
      if (lmi_optionn === "Threshold Opt-Out") {
        lmi_option = "No"
      } else {
        lmi_option = "Yes"
      }
      var dealStage

      if (l_dealStage === 127892578 /* completed */) {
        dealStage = "Complete"
      } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
        dealStage = "Complete"
      } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
        dealStage = "Complete"
      } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
        dealStage = "Complete"
      } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
        dealStage = "Complete"
      } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
        dealStage = "Complete"
      } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
        dealStage = "Complete"
      } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
        dealStage = "My Info"
      } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
        dealStage = "My Usage"
      } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
        dealStage = "My Info"
      } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
        dealStage = "My Info"
      } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
        dealStage = "My Info"
      } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
        dealStage = "My Usage"
      } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
        dealStage = "My Usage"
      } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
        dealStage = "My Usage"
      } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
        dealStage = "My Consent"
      } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
        dealStage = "My Consent"
      } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
        dealStage = "My Consent"
      } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
        dealStage = "My Consent"
      } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
        dealStage = "My Consent"
      } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
        dealStage = "My Usage"
      } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
        dealStage = "My Info"
      } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
        dealStage = "Complete"
      } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
        dealStage = "Complete"
      } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
        dealStage = "Dormant"
      } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
        dealStage = "Graveyard"
      } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
        dealStage = "Dormant"
      } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
        dealStage = "Graveyard"
      } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
        dealStage = "Trashcan"
      } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
        dealStage = "Trashcan"
      } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
        dealStage = "Assisted Create"
      } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
        dealStage = "Invite Sent"
      } else {
        dealStage = "Pending"
      }
      var name = storage.rawGet("name")
      var firstname = storage.rawGet("FirstName")
      var lastname = storage.rawGet("LastName")
      var dateOfBirth: any = storage.rawGet("DateOfBirth")
      var logEmail = storage.rawGet("logEmail")
      /* header content */
      var contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-header",
      ) as HTMLElement
      if (contentListSelector) {
        contentListSelector.innerHTML = ""
      }
      var contentList = `<ul><li>Account #${comb_utility_account_number}</li><li>${name}</li></ul>`
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      if (contentListSelector) {
        contentListSelector.innerHTML = ""
      }
      contentList = `<ul><li class="accountDetailsViewTitle">Status</li><li>${dealStage}</li></ul>`
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      if (storage.rawGet("FarmStateAbbreviation") === "IL") {
        completionDate = completionDateIl
      } else {
      }
      var dateObject = new Date(completionDate)
      // Format the date to YYYY-MM-DD
      var year: any = dateObject.getFullYear()
      var month: any = (dateObject.getMonth() + 1).toString().padStart(2, "0")
      var day: any = dateObject.getDate().toString().padStart(2, "0")
      completionDate = `${month}/${day}/${year}`
      if (year <= 2023) {
        completionDate = ""
      }
      contentList = '<ul><li class="accountDetailsViewTitle">Completion Date</li><li>' + completionDate + "</li></ul>"
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList = `<ul><li class="accountDetailsViewTitle">First Name</li><li>${firstname}</li></ul>`
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList = `<ul><li class="accountDetailsViewTitle">Last Name</li><li>${lastname}</li></ul>`
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      dateObject = new Date(dateOfBirth)
      // Format the date to YYYY-MM-DD
      year = dateObject.getFullYear()
      month = (dateObject.getMonth() + 1).toString().padStart(2, "0")
      day = dateObject.getDate().toString().padStart(2, "0")
      dateOfBirth = `${month}/${day}/${year}`
      contentList = `<ul><li class="accountDetailsViewTitle">DOB</li><li>${dateOfBirth}</li></ul>`
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList = `<ul><li class="accountDetailsViewTitle">Email Address</li><li>${logEmail}</li></ul>`
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList = '<ul><li class="accountDetailsViewTitle">Service Address</li><li>' + street_address_1 + "</li></ul>"
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList =
        '<ul><li class="accountDetailsViewTitle">Service Address 2</li><li>' + street_address_2 + "</li></ul>"
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList = '<ul><li class="accountDetailsViewTitle">Service City</li><li>' + service_city + "</li></ul>"
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList =
        '<ul><li class="accountDetailsViewTitle">Service State</li><li>' + service_state_abbreviation + "</li></ul>"
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList =
        '<ul><li class="accountDetailsViewTitle">Service Zip Code</li><li>' + Service_postal_code + "</li></ul>"
      contentListSelector.innerHTML += contentList

      if (enrollment_number != null) {
        contentListSelector = document.querySelector(
          ".accountDetailsView-inner .accountDetailsView-content",
        ) as HTMLElement
        contentList =
          '<ul><li class="accountDetailsViewTitle">Enrollment Number</li><li>' + enrollment_number + "</li></ul>"
        contentListSelector.innerHTML += contentList
      }
      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList =
        '<ul><li class="accountDetailsViewTitle">Utility Account Number</li><li>' +
        comb_utility_account_number +
        "</li></ul>"
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList = '<ul><li class="accountDetailsViewTitle">Payment Type</li><li>' + payment_method + "</li></ul>"
      contentListSelector.innerHTML += contentList

      contentListSelector = document.querySelector(
        ".accountDetailsView-inner .accountDetailsView-content",
      ) as HTMLElement
      contentList =
        '<ul><li class="accountDetailsViewTitle qDLID">Qualifies for Low-Income Discount</li><li class="qDLID">' +
        lmi_option +
        "</li></ul>"
      contentListSelector.innerHTML += contentList

      if (lmi_optionn == null || lmi_optionn === "") {
        document.querySelectorAll(".qDLID").forEach((li) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[li],["li"]);
          ;(li as HTMLElement).style.display = "none"
        })
      } else {
        document.querySelectorAll(".qDLID").forEach((li) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[li],["li"]);
          ;(li as HTMLElement).style.display = "block"
        })
      }

      enterZipcloseLoader()
      showDetailsViewPopup()
    } catch (error) {
      console.error("Error:", error)
      enterZipcloseLoader()
    }
  }

  // Index Db Part
  var request = indexedDB.open("myDatabase", 1)
  var db: IDBDatabase
  request.onerror = (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
    console.log(`Database error: ${(event.target as any).errorCode}`)
  }
  request.onsuccess = (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
    db = (event.target as IDBOpenDBRequest).result
  }
  request.onupgradeneeded = (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
    var db = (event.target as IDBOpenDBRequest).result

    // Create an object store (similar to a table in relational databases)
    var objectStore = db.createObjectStore("files", { autoIncrement: true })

    // Optionally, you can create indexes for efficient querying
    objectStore.createIndex("name", "name", { unique: false })
  }
  function clearDatabase() {
__ea_trace("modules/account/enrolled-accounts.ts","clearDatabase",[],[]);
    var transaction = db.transaction(Array.from(db.objectStoreNames), "readwrite")

    transaction.oncomplete = (_event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[_event],["_event"]);
    }

    transaction.onerror = (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
    }

    Array.from(db.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[storeName],["storeName"]);
      var objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }
  async function findAssociatedDeals() {
__ea_trace("modules/account/enrolled-accounts.ts","findAssociatedDeals",[],[]);
    var email = storage.rawGet("logEmail") as string
    email = email.toLowerCase()
    var catchdata: any = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      var recordId = dataa.userValue.properties.hs_object_id
      var onboardToken = dataa.userValue.properties.bayou_onboarding_token
      var bayouContactId = dataa.userValue.properties.bayou_contact_id
      var is_enrolled_for_bayou = dataa.userValue.properties.is_enrolled_for_bayou
      var bayou_reason = dataa.userValue.properties.bayou_reason
      storage.rawSet("RecordId", recordId)
      storage.rawSet("onboarding_token", onboardToken)
      storage.rawSet("bayou_contact_id", bayouContactId)
      storage.rawSet("bayou_reason", bayou_reason)
      if (is_enrolled_for_bayou === "yes") {
        storage.rawSet("is_enrolled_for_bayou", "yes")
      }
    } catch (error) {
      enterZipcloseLoader()
      console.error("Error:", error)
    }

    var contactId = storage.rawGet("contactId")
    catchdata = ""
    try {
      const data = {
        contactId: contactId,
      }
      const response = await fetch(apiUrl("FetchAssociatedDealsBasedOnContactId"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      var dealRecordLength = dataa.userValue.associations.deals.results.length
      void dealRecordLength
      var dealIdLog = dataa.userValue.associations.deals.results
      var checkIfAnyPrevDealWithIn24Hour = false
      var isAttributionCodeAvaialble = false
      var attributionCode
      var repId
      var refrralUrl
      var dealOwner: any
      for (var i = 0; i < dealIdLog.length; i++) {
        var deal = dealIdLog[i].id
        catchdata = ""
        try {
          const data = {
            deal_id: deal,
          }
          const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          catchdata = data
          const dataa = await response.json()
          responseFromAPI = JSON.stringify(dataa)
          var l_dealStage = dataa.userValue.properties.dealstage
          var log_repid = dataa.userValue.properties.attribution_rep
          var log_attcode = dataa.userValue.properties.attribution_code
          var log_refUrl = dataa.userValue.properties.referral_url
          var log_email = dataa.userValue.properties.deal_email_test
          void log_email
          var street_address_1 = dataa.userValue.properties.street_address
          var street_address_2 = dataa.userValue.properties.street_address_2
          var servicestateabbreviation = dataa.userValue.properties.service_state_abbreviation

          if (street_address_1 == null) {
            street_address_1 = ""
          }
          if (street_address_2 == null) {
            street_address_2 = ""
          }
          var stagedStageEnteredDate = dataa.userValue.properties.hs_v2_date_entered_127892570

          var log_dealOwner = dataa.userValue.properties.hubspot_owner_id
          var utility_id = dataa.userValue.properties.utility_id
          if (stagedStageEnteredDate != null) {
            var completionDateObject = new Date(stagedStageEnteredDate)
            var currentDate = new Date()
            var timeDifference = currentDate.getTime() - completionDateObject.getTime()
            var differenceInHours = timeDifference / (1000 * 60 * 60)
            if (differenceInHours <= 24) {
              checkIfAnyPrevDealWithIn24Hour = true
              if (log_attcode != null) {
                isAttributionCodeAvaialble = true
                attributionCode = log_attcode
                repId = log_repid
                refrralUrl = log_refUrl
                dealOwner = log_dealOwner
              }
            } else {
            }
          }
          var l_dealId = dataa.userValue.id
          var comb_utility_account_numberMain = dataa.userValue.properties.combined_utility_account_number
          var lmiMyUsage = dataa.userValue.properties.lmi_my_usage
          void lmiMyUsage
          var lmiOption = dataa.userValue.properties.lmi_option
          if (comb_utility_account_numberMain == null || comb_utility_account_numberMain === "") {
            comb_utility_account_numberMain = "Not Yet Provided"
          }
          var skip_bayou_submission = dataa.userValue.properties.skip_bayou_submission
          var dealStage
          var buttonBasedDealStage = "View Details"
          var buttonClassBasedDealStage = "submitted"
          if (l_dealStage === 127892578 /* completed */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 127892576 /* Interfaced (Sales Pipeline) */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 127892575 /* Staged (Sales Pipeline) */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 127892570 /* Submitted (Sales Pipeline) */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 157471033 /* Account Created (Sales Pipeline) */) {
            dealStage = "My Info"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "allStepsRemaining"
          } else if (l_dealStage === 157471034 /* My Info (Sales Pipeline) */) {
            dealStage = "My Info"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "allStepsRemaining"
          } else if (l_dealStage === 157471035 /* LMI Census Tract (Sales Pipeline) */) {
            dealStage = "My Info"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "MyInfo"
          } else if (l_dealStage === 127892566 /* LMI Manual (Sales Pipeline) */) {
            dealStage = "My Info"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "MyInfo"
          } else if (l_dealStage === 127892569 /* Usage (Sales Pipeline) */) {
            dealStage = "My Usage"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "UtilityInformation"
          } else if (l_dealStage === 127892567 /* Consent Signature (Sales Pipeline) */) {
            dealStage = "My Consent"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "ContractSignatures"
          } else if (l_dealStage === 127892568 /* Consent All (Sales Pipeline) */) {
            dealStage = "My Consent"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "PaymentInfo"
          } else if (l_dealStage === 127892571 /* Verify Utility Info (Sales Pipeline) */) {
            dealStage = "My Usage"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "UtilityCredentials"
          } else if (l_dealStage === 127892572 /* Verify LMI (Sales Pipeline) */) {
            dealStage = "My Info"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "MyInfo"
          } else if (l_dealStage === 127892573 /* Verify HU (Sales Pipeline) */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 127892574 /* Verified (Sales Pipeline) */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 127892577 /* Dormant (Sales Pipeline) */) {
            dealStage = "Dormant"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 127892579 /* Graveyard (Sales Pipeline) */) {
            dealStage = "Graveyard"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 127892580 /* Trashcan (Sales Pipeline) */) {
            dealStage = "Trashcan"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 157471031 /* Assisted Create (Sales Pipeline) */) {
            dealStage = "Assisted Create"
          } else if (l_dealStage === 157471032 /* Invite Sent (Sales Pipeline) */) {
            dealStage = "Invite Sent"
          } else if (l_dealStage === 984278683 /* 1. Account Creation (IL Pipeline) */) {
            dealStage = "My Usage"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "UtilityInformation"
          } else if (l_dealStage === 984278684 /* 2. Utility Info (IL Pipeline) */) {
            dealStage = "My Usage"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "UtilityInformation"
          } else if (l_dealStage === 984278685 /* 3. Usage Calculation (IL Pipeline) */) {
            dealStage = "My Usage"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "UtilityInformation"
          } else if (l_dealStage === 984278686 /* 4. Consent DF (IL Pipeline) */) {
            dealStage = "My Consent"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "ContractSignatures"
          } else if (l_dealStage === 984278687 /* 5. Consent All (IL Pipeline) */) {
            dealStage = "My Consent"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "ContractSignatures"
          } else if (l_dealStage === 984278688 /* 6. Consent Signature (IL Pipeline) */) {
            dealStage = "My Consent"
            buttonBasedDealStage = "Continue Enrollment"
            buttonClassBasedDealStage = "ContractSignatures"
          } else if (l_dealStage === 984278689 /* 7. Submitted (IL Pipeline) */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 984219225 /* 8. Staged (IL Pipeline) */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 984341032 /* 9. Interfaced (IL Pipeline) */) {
            dealStage = "Complete"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 984341033 /* Dormant (IL Pipeline) */) {
            dealStage = "Dormant"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 984341035 /* Graveyard (IL Pipeline) */) {
            dealStage = "Graveyard"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else if (l_dealStage === 984341036 /* Trashcan (IL Pipeline)  */) {
            dealStage = "Trashcan"
            buttonBasedDealStage = "View Details"
            buttonClassBasedDealStage = "submitted"
          } else {
            dealStage = "Pending"
          }
          var name = storage.rawGet("name")
          var contentListSelector = root.querySelector(".enrolledAccounts-list .listContent") as HTMLElement
          var contentList =
            '<ul dealid="' +
            l_dealId +
            '" utilityid="' +
            utility_id +
            '" lmioption="' +
            lmiOption +
            '" sbs="' +
            skip_bayou_submission +
            '" stabr="' +
            servicestateabbreviation +
            '"><li class="list_account">' +
            comb_utility_account_numberMain +
            '</li><li class="list_name">' +
            name +
            '</li><li class="list_address">' +
            street_address_1 +
            " " +
            street_address_2 +
            '</li><li class="list_status">' +
            dealStage +
            '</li><li class="lastBtn list_manage ' +
            buttonClassBasedDealStage +
            '">' +
            buttonBasedDealStage +
            "</li></ul>"
          contentListSelector.innerHTML += contentList
        } catch (error) {
          console.error("Error:", error)
          enterZipcloseLoader()
        }
      }

      if (checkIfAnyPrevDealWithIn24Hour === true) {
        if (isAttributionCodeAvaialble === true) {
          storage.rawSet("gotAttCode", "Yes")
          storage.rawSet("attcode", attributionCode)
          storage.rawSet("repid", repId)
          storage.rawSet("referralUrl", refrralUrl)
          storage.rawSet("dealOwner", dealOwner)
          ;(document.querySelector("#gsicode") as HTMLElement).style.display = "none"
        } else {
          var currentUrl = storage.rawGet("first_visited_url")
          const getQueryParam = (name: string) => {
__ea_trace("modules/account/enrolled-accounts.ts","getQueryParam",[name],["name"]);
            var urlParams = new URLSearchParams(currentUrl as string)
            return urlParams.get(name)
          }
          var attcode = getQueryParam("attcode")
          var reppid = getQueryParam("repid")
          if (attcode != null) {
            if (attcode !== "") {
              storage.rawSet("attcode", attcode)
              storage.rawSet("repid", reppid as string)
              storage.rawSet("referralUrl", currentUrl as string)
              ;(document.querySelector("#gsicode") as HTMLElement).style.display = "none"
            } else {
              ;(document.querySelector("#gsicode") as HTMLElement).style.display = "block"
            }
          } else {
            ;(document.querySelector("#gsicode") as HTMLElement).style.display = "block"
          }
        }
      } else {
        var currentUrl2 = storage.rawGet("first_visited_url")
        const getQueryParam2 = (name: string) => {
__ea_trace("modules/account/enrolled-accounts.ts","getQueryParam2",[name],["name"]);
          var urlParams = new URLSearchParams(currentUrl2 as string)
          return urlParams.get(name)
        }
        var attcode2 = getQueryParam2("attcode")
        var reppid2 = getQueryParam2("repid")
        if (attcode2 != null) {
          if (attcode2 !== "") {
            storage.rawSet("attcode", attcode2)
            storage.rawSet("repid", reppid2 as string)
            storage.rawSet("referralUrl", currentUrl2 as string)
            ;(document.querySelector("#gsicode") as HTMLElement).style.display = "none"
          } else {
            ;(document.querySelector("#gsicode") as HTMLElement).style.display = "block"
          }
        } else {
          ;(document.querySelector("#gsicode") as HTMLElement).style.display = "block"
        }
      }
      ;(root.querySelector(".enrolledAccounts-listSection") as HTMLElement).style.display = "block"
      enterZipcloseLoader()
    } catch (error) {
      enterZipcloseLoader()
      console.error("Error:", error)
    }

    /* --------------------------------------------------------------- */

    // Get all elements with the class 'lastBtn list_manage'
    var viewDetailButtons = document.querySelectorAll(".lastBtn.list_manage.submitted")
    var myInfoButton = document.querySelectorAll(".lastBtn.list_manage.allStepsRemaining")
    var lmiManualButton = document.querySelectorAll(".lastBtn.list_manage.MyInfo")
    var usageButton = document.querySelectorAll(".lastBtn.list_manage.UtilityInformation")
    var consentSignatureButton = document.querySelectorAll(".lastBtn.list_manage.ContractSignatures")
    var consentAllButton = document.querySelectorAll(".lastBtn.list_manage.PaymentInfo")
    var verifyUtilityButton = document.querySelectorAll(".lastBtn.list_manage.UtilityCredentials")

    /* ---------------------------------- Start click event of viewDetail --------------------------------- */
    viewDetailButtons.forEach((button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.addEventListener("click", (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
        enterZipOpenLoader()
        event.preventDefault()
        var ulElement = (event.target as HTMLElement).closest("ul") as HTMLElement
        var dealId = ulElement.getAttribute("dealid")
        var stateAB = ulElement.getAttribute("stabr")
        viewDealItems(dealId, stateAB)
      })
    })
    /* ---------------------------------- End click event of viewDetail --------------------------------- */
    /* ---------------------------------- Start click event of myInfo --------------------------------- */
    myInfoButton.forEach((button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.addEventListener("click", (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
        enterZipOpenLoader()
        clearDatabase()
        event.preventDefault()
        var ulElement = (event.target as HTMLElement).closest("ul") as HTMLElement
        var dealId = ulElement.getAttribute("dealid")
        var stateAB = ulElement.getAttribute("stabr")
        storage.rawSet("FarmStateAbbreviation", stateAB as string)
        var redirectUrl = "/my-info?mltenlmt"
        var particularSectionName: any = false
        var particularSectionValue: any = false
        CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue)
      })
    })
    /* ---------------------------------- Start click event of myInfo --------------------------------- */
    /* ---------------------------------- Start click event of lmi --------------------------------- */
    lmiManualButton.forEach((button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.addEventListener("click", (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
        enterZipOpenLoader()
        clearDatabase()
        event.preventDefault()
        var ulElement = (event.target as HTMLElement).closest("ul") as HTMLElement
        var dealId = ulElement.getAttribute("dealid")
        var stateAB = ulElement.getAttribute("stabr")
        storage.rawSet("FarmStateAbbreviation", stateAB as string)
        var redirectUrl = "/my-info?mltenlmt"
        var particularSectionName = "mil"
        var particularSectionValue = "MiLM"
        CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue)
      })
    })
    /* ---------------------------------- Start click event of lmi --------------------------------- */
    /* ---------------------------------- Start click event of myUsage --------------------------------- */
    usageButton.forEach(async (button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.addEventListener("click", async (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
        var ulElement = (event.target as HTMLElement).closest("ul") as HTMLElement
        /* getting credential provider */
        var exampleUtilityId = ulElement.getAttribute("utilityid")
        const hubDBEndpoint = hubdbRowsUrl("utilityAvailability", {
          utility_id__eq: exampleUtilityId as string,
        })
        const response = await fetch(hubDBEndpoint, { method: "GET" })
        const data = await response.json()
        const rows = data.objects
        if (rows.length >= 1) {
          rows.forEach((element: any) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[element],["element"]);
            if (exampleUtilityId === element.values["1"]) {
              storage.rawSet("SessionDetails", JSON.stringify(element.values))
              if (element.values["24"] !== undefined) {
                storage.rawSet("credentialProvider", element.values["24"].name)
              }
            }
          })
        } else {
        }

        /* getting credential provider */

        enterZipOpenLoader()
        clearDatabase()
        event.preventDefault()
        var credentialProvider = storage.rawGet("credentialProvider")
        ulElement = (event.target as HTMLElement).closest("ul") as HTMLElement
        var dealId = ulElement.getAttribute("dealid")
        var stateAB = ulElement.getAttribute("stabr")
        storage.rawSet("FarmStateAbbreviation", stateAB as string)
        var lmioption = ulElement.getAttribute("lmioption")
        storage.rawSet("lmi_option", lmioption as string)
        var redirectUrl = ""
        if (storage.rawGet("FarmStateAbbreviation") === "IL") {
          redirectUrl = "/il-usage" // redirect to normal hansen myusage page
        } else {
          if (credentialProvider === "NSE (Hansen)" && lmioption === "Threshold Opt-Out") {
            redirectUrl = "/my-usage" // redirect to normal hansen myusage page
          } else if (credentialProvider === "Bayou" && lmioption === "Threshold Opt-Out") {
            redirectUrl = "/myusage" // redirect to normal bayou myusage page
          } else if (credentialProvider === "Bayou") {
            redirectUrl = "/my_usage" // redirect to lmi bayou myusage page
          } else if (credentialProvider === "NSE (Hansen)") {
            redirectUrl = "/my-usage-lh" // redirect to lmi hansen myusage page
          } else {
            redirectUrl = "/my-usage"
          }
        }

        var particularSectionName: any = false
        var particularSectionValue: any = false
        CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue)
      })
    })
    /* ---------------------------------- Start click event of myUsage --------------------------------- */
    /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
    consentSignatureButton.forEach((button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.addEventListener("click", (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
        enterZipOpenLoader()
        clearDatabase()
        event.preventDefault()
        var ulElement = (event.target as HTMLElement).closest("ul") as HTMLElement
        var dealId = ulElement.getAttribute("dealid")
        var stateAB = ulElement.getAttribute("stabr")
        storage.rawSet("FarmStateAbbreviation", stateAB as string)
        var redirectUrl = ""
        if (storage.rawGet("FarmStateAbbreviation") === "IL") {
          redirectUrl = "/il-my-consent" // redirect to normal hansen myusage page
        } else {
          redirectUrl = "/my-consent"
        }
        var particularSectionName = "rp"
        var particularSectionValue = "NpEv"
        CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue)
      })
    })
    /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
    /* ---------------------------------- Start click event of MyConsent ConsentAll --------------------------------- */
    consentAllButton.forEach((button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.addEventListener("click", (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
        enterZipOpenLoader()
        clearDatabase()
        event.preventDefault()
        var ulElement = (event.target as HTMLElement).closest("ul") as HTMLElement
        var dealId = ulElement.getAttribute("dealid")
        var stateAB = ulElement.getAttribute("stabr")
        storage.rawSet("FarmStateAbbreviation", stateAB as string)
        var redirectUrl = "/my-consent"
        var particularSectionName = "rp"
        var particularSectionValue = "QxtVq"
        CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue)
      })
    })
    /* ---------------------------------- Start click event of MyConsent ConsentAll --------------------------------- */
    /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
    verifyUtilityButton.forEach((button) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[button],["button"]);
      button.addEventListener("click", (event) => {
__ea_trace("modules/account/enrolled-accounts.ts","(anon)",[event],["event"]);
        enterZipOpenLoader()
        clearDatabase()
        event.preventDefault()
        var ulElement = (event.target as HTMLElement).closest("ul") as HTMLElement
        var dealId = ulElement.getAttribute("dealid")
        var stateAB = ulElement.getAttribute("stabr")
        storage.rawSet("FarmStateAbbreviation", stateAB as string)
        var sbs = ulElement.getAttribute("sbs")
        // NOTE: `sbs = 'Yes'` is an assignment (always truthy), not a comparison —
        // preserved verbatim as a latent bug (see file header).
        var redirectUrl: any
        if ((sbs = "Yes")) {
          redirectUrl = "/myusageverification"
        } else {
          redirectUrl = "/my-usage-verification"
        }
        var particularSectionName: any = false
        var particularSectionValue: any = false
        CheckIfUserExist(dealId, redirectUrl, particularSectionName, particularSectionValue)
      })
    })
    /* ---------------------------------- Start click event of MyConsent Signature --------------------------------- */
  }
  findAssociatedDeals()
}
